import {
  GamewearSearchParams,
  RecolorOption,
  Sort,
  VRChatAvatarCompatibility,
  VRChatItemType,
  VRChatPlatform,
} from 'types/marketplace/confirmItem';
import { GameType } from 'types/marketplace';
import { getUtcDateDash, getUtcDateDashDifference } from 'modules/utils/time';
import { SearchDateTerms } from 'types/common/searchfilter';
import { SelectOption } from 'types/common/select';
import {
  generateInitialSearchParams,
  generateArrayValueKeys,
  toStringOptions,
} from 'modules/utils/filterUtils';
import { GAMEWEAR_FILTERS } from './gamewearFilterConfig';
import { DEFAULT_SEARCH_RESULTS_LIMIT } from './confirmItem';

export const gamewearInitialSearchParams: GamewearSearchParams = {
  ...generateInitialSearchParams(GAMEWEAR_FILTERS),
  dateFrom: getUtcDateDashDifference(new Date(), 6, 'month'),
  dateTo: getUtcDateDash(new Date()),
  dateTerm: SearchDateTerms['6_MONTHS'],
  page: 1,
  sort: Sort.LATEST_UPDATE,
  limit: DEFAULT_SEARCH_RESULTS_LIMIT,
} as GamewearSearchParams;

export const GAMEWEAR_ARRAY_VALUE_KEYS = generateArrayValueKeys(GAMEWEAR_FILTERS);

export const VRChatAvatarCompatibilityLabels = {
  [VRChatAvatarCompatibility.LUCY]: 'Lucy',
  [VRChatAvatarCompatibility.OTHERS]: 'Others',
};

export const VRChatPlatformLabels = {
  [VRChatPlatform.PC]: 'PC',
  [VRChatPlatform.QUEST]: 'Quest',
  [VRChatPlatform.PC_QUEST]: 'PC+Quest',
};

export const VRChatItemTypeLabels = {
  [VRChatItemType.CHARACTER]: 'Characters',
  [VRChatItemType.CLOTHING]: 'Clothing',
  [VRChatItemType.ACCESSORY]: 'Accessories',
  [VRChatItemType.POSE_MOTION]: 'Pose&Motion',
  [VRChatItemType.CHARACTER_FEATURES]: 'Character Features',
};

export const RecolorOptionLabels = {
  [RecolorOption.AVAILABLE]: 'Available',
  [RecolorOption.UNAVAILABLE]: 'Unavailable',
};

export const GameTypeLabels = {
  [GameType.INZOI]: 'inZOI',
  [GameType.VRCHAT]: 'VRChat',
};

export const GAME_TYPE_OPTIONS: SelectOption<string>[] = toStringOptions(GameTypeLabels);

export const RECOLOR_OPTIONS: SelectOption<number>[] = [
  { label: RecolorOptionLabels[RecolorOption.AVAILABLE], value: RecolorOption.AVAILABLE },
  { label: RecolorOptionLabels[RecolorOption.UNAVAILABLE], value: RecolorOption.UNAVAILABLE },
];

export const VRCHAT_AVATAR_COMPATIBILITY_OPTIONS: SelectOption<string>[] = toStringOptions(
  VRChatAvatarCompatibilityLabels,
);

export const VRCHAT_PLATFORM_OPTIONS: SelectOption<string>[] =
  toStringOptions(VRChatPlatformLabels);

export const VRCHAT_ITEM_TYPE_OPTIONS: SelectOption<string>[] =
  toStringOptions(VRChatItemTypeLabels);
